import { Graphics, Point } from 'pixi.js';
import { Vector2 } from 'three';
import { Dimensioning } from '../../core/dimensioning';

// class that handles the rendering for the temporary floor items
export class TemporaryFloorItem extends Graphics {
    constructor() {
        super();
        this.widthItem;
        this.depthItem;
    }

    setDimension(sizeX, sizeY) {
        this.widthItem = sizeX;
        this.depthItem = sizeY;
    }

    update(point) {
        this.clear();
        this.lineStyle(0, 0xF0F0F0);

        let a = point.clone().add(new Vector2(this.widthItem, this.depthItem));
        let b = point.clone().add(new Vector2(this.widthItem, -this.depthItem));
        let c = point.clone().add(new Vector2(-this.widthItem, -this.depthItem));
        let d = point.clone().add(new Vector2(-this.widthItem, this.depthItem));

        let points = [
            new Point(Dimensioning.cmToPixel(a.x), Dimensioning.cmToPixel(a.y)),
            new Point(Dimensioning.cmToPixel(b.x), Dimensioning.cmToPixel(b.y)),
            new Point(Dimensioning.cmToPixel(c.x), Dimensioning.cmToPixel(c.y)),
            new Point(Dimensioning.cmToPixel(d.x), Dimensioning.cmToPixel(d.y)),
        ];

        this.beginFill(0xFF007F, 0.50);
        this.drawPolygon(points);
        this.endFill();
    }
}
